import matchers from "../validate-props/matchers";
export const types = {
    ascending: "ascending",
    descending: "descending",
    unsorted: "unsorted",
};

/**
 * Designed to be used with Array.sort.
 * It makes asc/desc sorting over lists with objects
 * @param {Number} index
 * @param {types} sortType
 * @returns {Function}
 */
const sortByColumn = (index = 0, sortType = types.unsorted) => {
    /**
     * @param {Array.<{value}>} listA
     * @param {Array.<{value}>} listB
     * @return {Number}
     */
    return (listA, listB) => {
        //Invalid input keep the same order
        if (
            !matchers.number(index) ||
            !types[sortType] ||
            !matchers.array(listA) ||
            !matchers.array(listB) ||
            !matchers.object(listA[index]) ||
            !matchers.object(listB[index])
        ) {
            return 0;
        }

        const valA = listA[index].value;
        const valB = listB[index].value;

        if (valA === valB || sortType === types.unsorted) {
            return 0;
        }
        if (sortType === types.descending) {
            return valA < valB ? 1 : -1;
        }
        return valA > valB ? 1 : -1;
    };
};

export default sortByColumn;
